// extracted by mini-css-extract-plugin
export default {"tooltip":"HP-z","arrow":"IP-z"};